<template>
	<footer class="footer" v-if="pages">
		<div class="container">
			<div class="row">
				<div class="ft_links col-lg-9 col-md-9 col-sm-9">
					<div class="clearfix">
						<div
							class="ft_link_col"
							v-for="(item, index) in categoriesMenu"
							:key="index"
						>
							<div class="ft_link_title">
								<a-div
									:new-window="true"
									:href="parseLink(item.top.url)"
									>{{ item.top.title }}</a-div
								>
							</div>
							<div
								class="ft_link"
								v-for="(subitem, index) in item.inner"
								:key="index"
							>
								<a-div
									:href="parseLink(subitem.top.url)"
									:new-window="true"
									>{{ subitem.top.title }}</a-div
								>
							</div>
						</div>
					</div>
				</div>
				<div class="ft_col_right col-lg-3 col-md-3 col-sm-3 clearfix">
					<div class="ft_link_col">
						<div class="ft_logo">
							<router-link to="/">
								<LOGO />
							</router-link>
						</div>
						<div class="ft_service">
							<a-div
								:href="
									costumerServiceLink
										? parseLink(costumerServiceLink)
										: ''
								"
								:new-window="false"
								>שירות לקוחות >
							</a-div>
						</div>
					</div>
					<div class="ft_link_col ft_soc_m">
						<div
							class="ft_link_white"
							v-for="(item, index) in pagesMenu"
							:key="index"
						>
							<a-div :href="parseLink(item.top.url)">{{
								item.top.title
							}}</a-div>
						</div>
						<div class="ft_soc clearfix">
							<div class="right ft_soc_item ease">
								<a
									:href="globalOption.instagram_link"
									target="_blank"
								>
									<SC_INST />
								</a>
							</div>
							<div class="right ft_soc_item ease">
								<a
									:href="globalOption.facebook_link"
									target="_blank"
								>
									<SC_FACE />
								</a>
							</div>
							<div class="mobile_only right ft_soc_item ease">
								<a
									:href="
										'https://api.whatsapp.com/send?phone=972' +
										globalOption.whatsapp_phone.replace(
											'-',
											''
										)
									"
								>
									<WHATSUP />
								</a>
							</div>
							<div class="mobile_only right ft_soc_item ease">
								<a :href="'tel:' + globalOption.main_phone">
									<PHONE />
								</a>
							</div>
						</div>
					</div>
					<div class="mobile_only ft_links_m">
						<div
							class="ft_link_m"
							v-for="(item, index) in pagesMenu"
							:key="index"
						>
							<a-div :href="parseLink(item.top.url)">{{
								item.top.title
							}}</a-div>
						</div>
					</div>
				</div>
			</div>
      <div class="credits flex flex--end">
        <div class="ft_credit">
          עיצוב:
          <a :href="'http://www.3bears.co.il/'" target="_blank">3bears</a>
        </div>
        <div class="ft_credit">
          פיתוח:
          <a :href="'https://www.quatro-digital.com/'" target="_blank">Quatro</a>
        </div>
      </div>
		</div>
	</footer>
</template>

<script>
	import LOGO from "../../assets/img/carmella.svg";
	import SC_INST from "../../assets/img/sc_inst.svg";
	import SC_FACE from "../../assets/img/sc_face.svg";
	import WHATSUP from "../../assets/img/soc_whatsup.svg";
	import QUATRO from "../../assets/img/quatro.svg";
	import PHONE from "../../assets/img/phone-full.svg";

	export default {
		props: ["pages"],
		data() {
			return {
				globalOption: wpData.globalOptions,
				costumerServiceLink: wpData.globalOptions.pages.service,
			};
		},
		mounted() {},
		methods: {
			getPage(id) {
				return this.pages.find((p) => p.id === id);
			},
			getPageLink(id) {
				var page = this.pages.find((p) => p.id === id);
				if (page) {
					return decodeURI(page.slug);
				}
			},
			parseLink(link) {
				return link.replace(wpData.home_url, "");
			},
		},
		computed: {
			categoriesMenu() {
				return JSON.parse(wpData.footer_menu_categories);
			},
			pagesMenu() {
				return JSON.parse(wpData.footer_menu);
			},
		},
		components: {
			QUATRO,
			WHATSUP,
			SC_INST,
			SC_FACE,
			LOGO,
			PHONE,
		},
	};
</script>

<style scoped lang="sass">
footer.footer .credits
  column-gap: 15px
</style>